var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "97fd31f39553fdce8d04a8b83179dbb6d0de8a60"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["nc_accthome@enova"] = {
  id: "97fd31f39553fdce8d04a8b83179dbb6d0de8a60"
};